

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';
import Sidebar from '../sidebar/Sidebar'; 
import Loader from '../../UserSide/Components/LoaderComponent'; 
import { ToastContainer, toast } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css'; 

import { BASE_URL } from '../../Services';
import { useUser } from '../../Services/UserContext';

const ParticipantDetails = () => {
    const { id } = useParams();
    const [participant, setParticipant] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isSidebarOpen, setIsSidebarOpen] = useState(true); 
    const { userData } = useUser();

    useEffect(() => {
        const fetchParticipant = async () => {
            try {
                const response = await axios.get(`${BASE_URL}/participants/${id}`, {
                    headers: {
                        Authorization: `Bearer ${userData?.token}`
                    }
                });
                if (response.status === 200) {
                    setParticipant(response.data);
                } else {
                    toast.error('Failed to fetch participant details.');
                }
            } catch (error) {
                console.error('Error fetching participant:', error.response ? error.response.data : error.message);
                toast.error('Error fetching participant details.');
            } finally {
                setLoading(false);
            }
        };
        fetchParticipant();
    }, [id]);// eslint-disable-line

    const handleSidebarToggle = (isOpen) => {
        setIsSidebarOpen(isOpen);
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <Loader /> 
            </div>
        );
    }

    if (!participant) {
        return <p className="text-center text-danger">No participant found</p>;
    }

    const parseProducts = (products) => {
        if (typeof products === 'string') {
            try {
                const parsed = JSON.parse(products);
                return Array.isArray(parsed) ? parsed : [];
            } catch (error) {
                console.error('Error parsing products JSON:', error);
                return [];
            }
        }
        return Array.isArray(products) ? products : [];
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <Sidebar onToggleSidebar={handleSidebarToggle} />
                <div className={`col ${isSidebarOpen ? 'col-md-10' : 'col-md-12 mt-3'} ms-auto`}>
                    <div className="dashboard-content px-4">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h1 className="fs-3 fw-bold text-dark shadow p-3 mb-2 bg-light rounded">
                                Participant Details
                            </h1>
                            <Link to="/dashboard/participants" className="btn btn-secondary shadow-sm">
                                <i className="bi bi-arrow-left me-2"></i> Back to Participants List
                            </Link> 
                        </div>

                        <div className="card shadow-lg border-0 rounded" >
                            <div className="card-body">
                                <h5 className="card-title">Participant ID: {participant.id}</h5>
                                <p><strong>Processed Invoice ID:</strong> {participant.processed_invoice ? participant.processed_invoice.invoice_id : 'N/A'}</p>
                                <p><strong>Total Amount:</strong> {Number(participant.total_amount).toFixed(2)} - PKR</p>
                                <p><strong>User Number:</strong> {participant.userNumber}</p>
                                <p><strong>Answer:</strong> {participant.processed_invoice ? participant.processed_invoice.is_correct : 'N/A'}</p>
                                <p><strong>User ID:</strong>{participant.processed_invoice && participant.processed_invoice.user ? participant.processed_invoice.user.id : 'N/A'}</p>
                                <p><strong>User Name:</strong> {participant.processed_invoice && participant.processed_invoice.user ? participant.processed_invoice.user.name : 'N/A'}</p>

                                <p><strong>User Email:</strong> {participant.processed_invoice && participant.processed_invoice.user ? participant.processed_invoice.user.email : 'N/A'}</p>
 
                                <p><strong>User Phone:</strong> {participant.processed_invoice && participant.processed_invoice.user ? participant.processed_invoice.user.phone : 'N/A'}</p>
                                <p><strong>Answer Time:</strong> {participant.processed_invoice && participant.processed_invoice ? participant.processed_invoice.answer_time : 'N/A'}</p>
 

                                <p><strong>Rewards:</strong></p>
                                <ul className="list-group">
                                    {participant.processed_invoice && participant.processed_invoice.products ? (
                                        parseProducts(participant.processed_invoice.products).map((product, index) => (
                                            <li key={index}>
                                            
                                                {product.reward ? product.reward.name : 'N/A'}
                                            
                                            </li>
                                            
                                        ))
                                    ) : (
                                        <li>No products or invalid products data</li>
                                    )}
                                </ul>

                                <p><strong>Products:</strong></p>
                                <ul className="list-group">
                                    {participant.processed_invoice && participant.processed_invoice.products ? (
                                        parseProducts(participant.processed_invoice.products).map((product, index) => (
                                            <li key={index}>
                                                <p><strong>Product ID:</strong> {product.product_id}</p>
                                                <p><strong>Product name:</strong> {product.name}</p>
                                                <p><strong>Quantity:</strong> {product.quantity}</p>
                                                <p><strong>Price:</strong> {product.price}</p>
                                                <p><strong>Product Reward:</strong> {product.reward ? product.reward.name : 'N/A'}</p>
                                            </li>
                                        ))
                                    ) : (
                                        <li>No products or invalid products data</li>
                                    )}
                                </ul>

                                <p><strong>Payment Response:</strong></p>
                                <pre>{JSON.stringify(participant.payment_response, null, 2)}</pre>
                            </div>
                        </div>

                        <ToastContainer /> 
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ParticipantDetails;
